import * as styles from './TableControlBar.module.css'

function TableControlBar({ children, className = styles.TableControlBar }) {
  return <div className={className}>{children}</div>
}

export default TableControlBar
